module.exports = __webpack_public_path__ + "static/media/globe.9f496ff8.svg";